import { useEffect } from 'react';

/**
 * The catalog export screens' base type (utilities.css `html.catalog-export-type`): 14px / 1.45
 * like the approved prototype, instead of the browser's 16px / 1.5. Set on <html> so portalled
 * sheets, dialogs and popovers get it too; removed when leaving the screen.
 */
export function useCatalogExportType(): void {
  useEffect(() => {
    document.documentElement.classList.add('catalog-export-type');
    return () => {
      document.documentElement.classList.remove('catalog-export-type');
    };
  }, []);
}
